import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LeagueGetStarted.css';

const LeagueGetStarted = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    leagueName: '',
    sport: '',
    location: '',
    teamCount: '',
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const set = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const validate = () => {
    const e = {};
    if (!form.leagueName.trim()) e.leagueName = 'Required';
    if (!form.sport.trim()) e.sport = 'Required';
    if (!form.contactName.trim()) e.contactName = 'Required';
    if (!form.contactEmail.trim()) e.contactEmail = 'Required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.contactEmail)) e.contactEmail = 'Invalid email';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="lgs-success">
        <div className="lgs-success-icon">✓</div>
        <h2>Request Received!</h2>
        <p>We'll reach out to <strong>{form.contactName}</strong> at <strong>{form.contactEmail}</strong> within 1–2 business days.</p>
        <button className="lgs-btn-primary" onClick={() => navigate('/standouts')}>
          Back to Standouts
        </button>
      </div>
    );
  }

  return (
    <div className="league-get-started">
      <button className="lgs-back" onClick={() => navigate('/standouts')}>
        <img src="/assets/images/standout-back.png" alt="" style={{width:"14px",height:"auto",marginRight:"6px",verticalAlign:"middle"}} />Back to Standouts
      </button>

      <div className="lgs-layout">
        {/* Left Info */}
        <div className="lgs-info">
          <span className="lgs-eyebrow">For Leagues</span>
          <h1 className="lgs-title">Get Your League on Standouts</h1>
          <p className="lgs-subtitle">
            Give your athletes a place to be recognized every week. Standouts is free for leagues during our launch period.
          </p>
          <div className="lgs-benefits">
            <div className="lgs-benefit">
              <span className="lgs-benefit-icon">🏆</span>
              <div>
                <strong>Weekly Recognition</strong>
                <p>Coaches select top performers every week — automatically published.</p>
              </div>
            </div>
            <div className="lgs-benefit">
              <span className="lgs-benefit-icon">📱</span>
              <div>
                <strong>Shareable Profiles</strong>
                <p>Every athlete gets a shareable card — perfect for parents and social media.</p>
              </div>
            </div>
            <div className="lgs-benefit">
              <span className="lgs-benefit-icon">📊</span>
              <div>
                <strong>Permanent Record</strong>
                <p>Every standout stays on record — a lasting legacy for your athletes.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Form */}
        <form className="lgs-form" onSubmit={handleSubmit}>
          <h3 className="lgs-form-title">Tell us about your league</h3>

          <div className="lgs-row">
            <div className="lgs-field">
              <label>League Name *</label>
              <input
                type="text"
                placeholder="e.g. Temecula Valley Youth League"
                value={form.leagueName}
                onChange={(e) => set('leagueName', e.target.value)}
                className={errors.leagueName ? 'error' : ''}
              />
              {errors.leagueName && <span className="lgs-error">{errors.leagueName}</span>}
            </div>
            <div className="lgs-field">
              <label>Sport *</label>
              <input
                type="text"
                placeholder="e.g. Basketball, Football"
                value={form.sport}
                onChange={(e) => set('sport', e.target.value)}
                className={errors.sport ? 'error' : ''}
              />
              {errors.sport && <span className="lgs-error">{errors.sport}</span>}
            </div>
          </div>

          <div className="lgs-row">
            <div className="lgs-field">
              <label>Location</label>
              <input
                type="text"
                placeholder="City, State"
                value={form.location}
                onChange={(e) => set('location', e.target.value)}
              />
            </div>
            <div className="lgs-field">
              <label>Number of Teams</label>
              <input
                type="number"
                placeholder="e.g. 12"
                min="1"
                value={form.teamCount}
                onChange={(e) => set('teamCount', e.target.value)}
              />
            </div>
          </div>

          <div className="lgs-row">
            <div className="lgs-field">
              <label>Your Name *</label>
              <input
                type="text"
                placeholder="Contact name"
                value={form.contactName}
                onChange={(e) => set('contactName', e.target.value)}
                className={errors.contactName ? 'error' : ''}
              />
              {errors.contactName && <span className="lgs-error">{errors.contactName}</span>}
            </div>
            <div className="lgs-field">
              <label>Email *</label>
              <input
                type="email"
                placeholder="your@email.com"
                value={form.contactEmail}
                onChange={(e) => set('contactEmail', e.target.value)}
                className={errors.contactEmail ? 'error' : ''}
              />
              {errors.contactEmail && <span className="lgs-error">{errors.contactEmail}</span>}
            </div>
          </div>

          <div className="lgs-field">
            <label>Phone (Optional)</label>
            <input
              type="tel"
              placeholder="(555) 000-0000"
              value={form.contactPhone}
              onChange={(e) => set('contactPhone', e.target.value)}
            />
          </div>

          <div className="lgs-field">
            <label>Anything else we should know?</label>
            <textarea
              rows={3}
              placeholder="Tell us about your season schedule, divisions, or any questions..."
              value={form.message}
              onChange={(e) => set('message', e.target.value)}
            />
          </div>

          <button type="submit" className="lgs-btn-primary">
            Submit Request
          </button>
        </form>
      </div>
    </div>
  );
};

export default LeagueGetStarted;
